var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"id":_vm.id,"type":"color"},domProps:{"value":_vm.currentValue},on:{"input":_vm.updateColor}})])
}
var staticRenderFns = []

export { render, staticRenderFns }